export default "__VITE_ASSET__DGeJaglM__"